import styled, { isCanvasTheme } from 'foundations-theming/utils';
import { ONBOARDING_COLOR } from './colors';
export const TourButtonLabel = styled.div.withConfig({
  displayName: "styles__TourButtonLabel"
})([".hs-private.hs-private.hs-private &{font-family:", ";font-size:", ";font-weight:", ";color:", ";}"], ({
  theme
}) => theme.typography['body-600'].fontFamily, ({
  theme
}) => theme.typography['detail-100'].fontSize, ({
  theme
}) => theme.typography['body-125'].fontWeight, ({
  theme
}) => isCanvasTheme(theme) ? 'inherit' : theme.color[ONBOARDING_COLOR]);
export const OnFillLinkOverride = styled.div.withConfig({
  displayName: "styles__OnFillLinkOverride"
})([".hs-private.hs-private.hs-private &{--trellis-color-text-interactive-default:var( --trellis-color-text-interactive-on-fill-default );--trellis-color-text-interactive-default-hover:var( --trellis-color-text-interactive-on-fill-hover );--trellis-color-text-interactive-default-pressed:var( --trellis-color-text-interactive-on-fill-pressed );}.hs-private.hs-private.hs-private & a:not([data-button-use]){text-decoration:underline;}.hs-private.hs-private.hs-private & a[data-button-use]:hover{text-decoration:none;}"]);